import styled from 'styled-components';

/** Nakładka na obszar planszy. Plansza zostaje zamontowana pod spodem, więc
 *  eksport z górnego paska działa dalej. */
export const ComposerOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  overflow-y: auto;
`;

export const ComposerHeader = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 24px 0;
`;

export const ComposerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 16px 24px 24px;
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
`;

export const ComposerTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.3;
`;

export const ComposerHint = styled.p`
  font-size: 12px;
  color: #71717a;
  line-height: 1.6;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FieldTitle = styled.h4`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #71717a;
`;

export const PickerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: 8px;
`;

export const PickerTile = styled.button<{ $selected: boolean }>`
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  background: #f4f4f5;
  border: 2px solid ${({ $selected }) => ($selected ? '#0b4f9e' : '#e4e4e7')};
  transition: border-color 0.15s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover {
    border-color: #0b4f9e;
  }
`;

export const TileBadge = styled.span`
  position: absolute;
  top: 4px;
  left: 4px;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 10px;
  line-height: 1.5;
  color: #ffffff;
  background: #0b4f9e;
`;

export const ReferenceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    width: 64px;
    height: 64px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid #e4e4e7;
  }
`;
